import { render, staticRenderFns } from "./Activity1_5Radio.vue?vue&type=template&id=7b3cd1e2&"
import script from "./Activity1_5Radio.vue?vue&type=script&lang=js&"
export * from "./Activity1_5Radio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports